#define PI 3.1415926535897932384626433832795

varying vec2 vUv;

vec2 rotate(vec2 uv, float rotation, vec2 mid)
{
    return vec2(
      cos(rotation) * (uv.x - mid.x) + sin(rotation) * (uv.y - mid.y) + mid.x,
      cos(rotation) * (uv.y - mid.y) - sin(rotation) * (uv.x - mid.x) + mid.y
    );
}

void main()
{

//    vec2 rUV = rotate(mod(vUv*2.0,1.0), (PI*0.25), vec2(0.5,0.5));

    vec2 rUV = rotate(vUv, (PI*0.25), vec2(0.5,0.5));
    //vec2 rUV = vUv;
    float str = 0.5;
    //float dist = distance(vUv, vec2(0.2,0.5))+ 0.25 ;
    // float circle1 = step(0.4, distance(rUV, vec2(0.185,0.5))+ 0.25 );
    // float circle2 = step(0.4, distance(rUV, vec2(0.4,0.5))+ 0.25 );
    // float circle3 = step(0.4, distance(rUV, vec2(0.615,0.5))+ 0.25 );
    
    // float circle4 = step(0.4, distance(rUV, vec2(0.4,0.715))+ 0.25 );
    // float circle5 = step(0.4, distance(rUV, vec2(0.4,0.285))+ 0.25 );


    float circle1 = step(0.39, distance(rUV, vec2(0.1,0.5))+ 0.25 ); //edge
    float circle13 = step(0.39, distance(rUV, vec2(0.1,0.7))+ 0.25 ); //edge row2
    float circle2 = step(0.39, distance(rUV, vec2(0.3,0.5))+ 0.25 ); // middle1
    float circle4 = step(0.39, distance(rUV, vec2(0.3,0.7))+ 0.25 );
    float circle5 = step(0.39, distance(rUV, vec2(0.3,0.3))+ 0.25 );

    float circle3 = step(0.39, distance(rUV, vec2(0.5,0.5))+ 0.25 ); // middle2
    float circle6 = step(0.39, distance(rUV, vec2(0.5,0.7))+ 0.25 );
    float circle7 = step(0.39, distance(rUV, vec2(0.5,0.3))+ 0.25 );

    float circle8 = step(0.39, distance(rUV, vec2(0.7,0.5))+ 0.25 ); // middle3
    float circle9 = step(0.39, distance(rUV, vec2(0.7,0.7))+ 0.25 );
    float circle10 = step(0.39, distance(rUV, vec2(0.7,0.3))+ 0.25 );

    float circle11 = step(0.39, distance(rUV, vec2(0.9,0.5))+ 0.25 ); // edge
    float circle12 = step(0.39, distance(rUV, vec2(0.9,0.7))+ 0.25 ); // edge row2
    
    float circle14 = step(0.39, distance(rUV, vec2(0.1,0.3))+ 0.25 ); // edge below
    float circle15 = step(0.39, distance(rUV, vec2(0.9,0.3))+ 0.25 ); // edge below


    float ey1 = step(0.39, distance(rUV, vec2(0.3,0.9))+ 0.25 ); // edge row2
    float ey2 = step(0.39, distance(rUV, vec2(0.5,0.9))+ 0.25 ); // edge row2
    float ey3 = step(0.39, distance(rUV, vec2(0.7,0.9))+ 0.25 ); // edge row2

    float ed1 = step(0.39, distance(rUV, vec2(0.3,0.1))+ 0.25 ); // edge row2
    float ed2 = step(0.39, distance(rUV, vec2(0.5,0.1))+ 0.25 ); // edge row2
    float ed3 = step(0.39, distance(rUV, vec2(0.7,0.1))+ 0.25 ); // edge row2


    //str = circle1*circle2*circle3;
    str =  (circle1+circle2)*(circle2+circle3)*(circle3+circle8)*(circle8+circle11);
    str *= (circle13+circle4)*(circle4+circle6)*(circle6+circle9)*(circle9+circle12); //row above
    str *= (circle4+ey1)*(circle6+ey2)*(circle9+ey3); //row above edge
    
    str *= (circle14+circle5)*(circle5+circle7)*(circle7+circle10)*(circle10+circle15); //row above
    str *= (circle5+ed1)*(circle7+ed2)*(circle10+ed3); //row above edge

    //str = (circle1+circle2)*(circle2+circle3)*(circle4+circle2)*(circle2+circle5);
    str *= (circle4+circle2)*(circle2+circle5)*(circle3+circle6)*(circle3+circle7)*(circle8+circle9)*(circle8+circle10);




    //str = circle1+circle2;//+circle3;

    gl_FragColor = vec4(vec3(str),1.0);
//    gl_FragColor = vec4(vUv, 1.0, 1.0);
}